require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-allie-from-university-stem-professor-to-code-fellows-instructor.json") })
        }
      }, "path---blog-meet-allie-from-university-stem-professor-to-code-fellows-instructor");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-allie-from-university-stem-professor-to-code-fellows-instructor!./.cache/json/blog-meet-allie-from-university-stem-professor-to-code-fellows-instructor.json
// module id = 948
// module chunks = 231608221292675